import { Link } from "wouter";
import { FaLinkedin, FaInstagram, FaFacebook, FaXTwitter } from "react-icons/fa6";
import { Logo } from "../common/Logo";

export function Footer() {
  return (
    <footer className="border-t border-border/40 bg-background pt-16 pb-8">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8 lg:gap-12 mb-16">
          <div className="col-span-1 md:col-span-1">
            <Link href="/" className="flex items-center gap-2 mb-4">
              <Logo className="h-10 w-auto" />
            </Link>
            <p className="text-sm text-muted-foreground mb-6 max-w-xs">
              We Don't Just Build — We Accelerate. Mumbai-based elite software development agency.
            </p>
            <div className="flex gap-4">
              <a href="https://www.linkedin.com/company/acceleratebyte" target="_blank" rel="noreferrer" className="text-muted-foreground hover:text-[#0A66C2] transition-colors">
                <FaLinkedin className="h-5 w-5" />
                <span className="sr-only">LinkedIn</span>
              </a>
              <a href="https://x.com/acceleratebyte" target="_blank" rel="noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">
                <FaXTwitter className="h-5 w-5" />
                <span className="sr-only">X (Twitter)</span>
              </a>
              <a href="https://www.instagram.com/acceleratebyte/" target="_blank" rel="noreferrer" className="text-muted-foreground hover:text-[#E4405F] transition-colors">
                <FaInstagram className="h-5 w-5" />
                <span className="sr-only">Instagram</span>
              </a>
              <a href="https://www.facebook.com/people/AccelerateByte-App-Website-Development/61567391273186/" target="_blank" rel="noreferrer" className="text-muted-foreground hover:text-[#1877F2] transition-colors">
                <FaFacebook className="h-5 w-5" />
                <span className="sr-only">Facebook</span>
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-display font-semibold text-foreground mb-4">Services</h3>
            <ul className="space-y-3">
              <li><Link href="/services/website-development" className="text-sm text-muted-foreground hover:text-primary transition-colors">Web Development</Link></li>
              <li><Link href="/services/mobile-app-development" className="text-sm text-muted-foreground hover:text-primary transition-colors">Mobile Apps</Link></li>
              <li><Link href="/services/mvp-launch" className="text-sm text-muted-foreground hover:text-primary transition-colors">MVP Launch</Link></li>
              <li><Link href="/services/ui-ux-redesign" className="text-sm text-muted-foreground hover:text-primary transition-colors">UI/UX Redesign</Link></li>
              <li><Link href="/services" className="text-sm text-muted-foreground hover:text-primary transition-colors">All Services →</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-display font-semibold text-foreground mb-4">Company</h3>
            <ul className="space-y-3">
              <li><Link href="/about" className="text-sm text-muted-foreground hover:text-primary transition-colors">About Us</Link></li>
              <li><Link href="/work" className="text-sm text-muted-foreground hover:text-primary transition-colors">Our Work</Link></li>
              <li><Link href="/blog" className="text-sm text-muted-foreground hover:text-primary transition-colors">Blog</Link></li>
              <li><Link href="/contact" className="text-sm text-muted-foreground hover:text-primary transition-colors">Contact</Link></li>
              <li><Link href="/tool/audit/ttfb" className="text-sm text-muted-foreground hover:text-primary transition-colors">Performance Audit</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-display font-semibold text-foreground mb-4">Legal & Help</h3>
            <ul className="space-y-3">
              <li><Link href="/help" className="text-sm text-muted-foreground hover:text-primary transition-colors">FAQ</Link></li>
              <li><Link href="/privacy" className="text-sm text-muted-foreground hover:text-primary transition-colors">Privacy Policy</Link></li>
              <li><Link href="/terms" className="text-sm text-muted-foreground hover:text-primary transition-colors">Terms of Service</Link></li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center pt-8 border-t border-border/40 gap-4 text-xs text-muted-foreground">
          <p>© 2026 AccelerateByte. All rights reserved.</p>
          <div className="flex gap-4">
            <span>Mumbai, India</span>
            <span>·</span>
            <span>hello@acceleratebyte.com</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
